import * as React from "react";
import { CommonText, Content } from "@lib/components";
import { RestaurantMenuList } from "./list.menus";
import { RestaurantOptionSetList } from "./list.option_sets";
import { RestaurantDishTags } from "./list.tags";
import { MenuListToolbar } from "./components/menu-list-toolbar";
import { getMenuListFilterPlaceholder, MenuListSortDirection } from "./utils/sortLists";
import { RestaurantMenuTemplates } from "./templates";
import { RestaurantMenuUploadService } from "./upload-service";
import { inject, observer } from "mobx-react";
import { MobxComponent } from "../../../../../mobx/components";
import { Button } from "@lib/components";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from "@lib/components";
import styled from "styled-components";
import { CSVExport } from "./csv-export";
import { CSVImport } from "./csv-import";
import { MenuPOSSync } from "./pos-sync";
import { MenuVersionHistory } from "./version-history";
import { MenuPresence } from "../../../../components/menu-presence";

interface Props { }
interface State {
  tab: string;
  filterText: string;
  sortDirection: MenuListSortDirection;
}

@inject("store") @observer
export class RestaurantMenus extends MobxComponent<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      tab: "0",
      filterText: "",
      sortDirection: null,
    };
  }

  componentDidMount(): void {
    this.injected.store.getRestaurantStock(this.injected.store.restaurant!._id);
    // Announce on the restaurant channel that a menu screen is open. The
    // original dashboard saves the whole menu array at once, so knowing a
    // colleague is already in here is worth more than it is on V2.
    this.injected.store.notifications.menuPresenceMounted(null);
  }

  componentWillUnmount(): void {
    this.injected.store.notifications.menuPresenceUnmounted(null);
  }

  render() {
    const { tab, filterText, sortDirection } = this.state;
    const { isMainReseller, auth, restaurant } = this.injected.store;
    const toolbarSortableCount =
      tab === "0"
        ? restaurant?.menus?.length ?? 0
        : tab === "1"
        ? restaurant?.option_sets?.length ?? 0
        : 0;
    const loginEmail = auth?.item?.email;
    const allowAll = auth?.item?.restrictions;
    const menus_detail = auth?.item?.restrictions?.restaurant?.menus_detail

    const exportPermisson = menus_detail?.export;
    const importPermisson = menus_detail?.import;

    let options =
      [
        { name: "Menu", value: "0" },
        { name: "Option Sets", value: "1" },
        { name: "Item Tags", value: "2" },
      ];

    const isSupportLogin: any = (loginEmail?.toLowerCase() == "support@cloudwaitress.com");
    let canExport = isSupportLogin || exportPermisson;
    let canImport = isSupportLogin || importPermisson;

    if (!allowAll) {
      canExport = true;
      canImport = true;
    }


    return (
      <>
        <Content width="lg">

          <div className="flex-l-r-center m-b-6">
            <h1>Menus</h1>
            <div className="m-l-2 child-mr-10">
              <MenuPresence />
              <MenuPOSSync />
              <RestaurantMenuTemplates />
              <MenuVersionHistory />
              {isMainReseller && <RestaurantMenuUploadService />}
              {(() => {
                if (canExport && canImport) {
                  return (
                    <>
                      <CSVExport />
                      <CSVImport />
                    </>
                  );
                }

                if (canExport) {
                  return <CSVExport />;
                }

                if (canImport) {
                  return <CSVImport />;
                }

                return null;
              })()}
              {isMainReseller && (
                <Tooltip text={"Help"} width={50} position={"top"}>
                  <a target="_blank" href="https://support.cloudwaitress.com/getting-started/setup-your-menus">
                    <Button size="xxs" color="white" className="p-lr-1">
                      <FaQuestionCircle />
                    </Button>
                  </a>
                </Tooltip>
              )}
            </div>
          </div>

          <MenuListToolbar
            tabs={options}
            activeTab={tab}
            onTabChange={(value) =>
              this.setState({ tab: value, filterText: "", sortDirection: null })
            }
            filterText={filterText}
            onFilterTextChange={(value) => this.setState({ filterText: value })}
            filterPlaceholder={getMenuListFilterPlaceholder(tab)}
            sortDirection={sortDirection}
            onSortDirectionChange={(direction) => this.setState({ sortDirection: direction })}
            showFilter={tab === "0" || tab === "1"}
            showSort={tab === "0" || tab === "1"}
            sortableItemCount={toolbarSortableCount}
          />

          <div>
            {tab === "0" && (
              <RestaurantMenuList
                filterText={filterText}
                sortDirection={sortDirection}
              />
            )}
            {tab === "1" && (
              <RestaurantOptionSetList
                filterText={filterText}
                sortDirection={sortDirection}
                onSortDirectionChange={(direction) => this.setState({ sortDirection: direction })}
              />
            )}
            {tab === "2" && (
              <RestaurantDishTags />
            )}
          </div>

        </Content>
      </>
    );
  }
}
